export default "data:image/gif;base64,R0lGODlhEgAMAPEDAACLAP8AAP//AP///yH5BAAAAAAALAAAAAASAAwAAAIphB+pm4cMnZiQHWGCqMrgAWpc4AHgIHLep21qubnvKs/PSDoA3uh8UAAAOw=="